var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "16.794",
        viewBox: "0 0 10.433 16.794",
        width: "10.433",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "Icon_open-question-mark",
          d: "M5.185,0A5.425,5.425,0,0,0,1.239,1.385,4.581,4.581,0,0,0,0,4.072l2.1.273A2.544,2.544,0,0,1,2.75,2.9a3.117,3.117,0,0,1,2.435-.8,3.7,3.7,0,0,1,2.561.714A1.755,1.755,0,0,1,8.334,4.2c0,1.742-.714,2.225-1.763,3.149A5.983,5.983,0,0,0,4.135,12.07V12.6h2.1V12.07c0-1.742.651-2.225,1.7-3.149a6.019,6.019,0,0,0,2.5-4.723,4.033,4.033,0,0,0-1.239-2.96A5.8,5.8,0,0,0,5.185,0ZM4.135,14.694v2.1h2.1v-2.1Z",
          "data-name": "Icon open-question-mark",
          fill: "#1bc5bd",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }